function getPermissions() {
  try {
    return localStorage.permissions ? JSON.parse(localStorage.permissions) : {};
  } catch (error) {
    return {};
  }
}

export function isAdminUser() {
  const permissions = getPermissions();
  return permissions?.is_superuser === true;
}

export function isStaffUser() {
  return localStorage?.is_staff === "true";
}

function hasPermission(permission) {
  const permissions = getPermissions();
  return isAdminUser() || Boolean(permissions?.[permission]);
}

export function isFreelanceUser() {
  return (
    !isAdminUser() &&
    !isStaffUser() &&
    localStorage?.is_freelance === "true"
  );
}

export function canFreelanceViewArchivedFiles() {
  return hasPermission("can_view_archive_files");
}

export function canFreelanceViewCustomers() {
  return false;
}

export function isFreelanceRouteAllowed(pathname) {
  if (!isFreelanceUser()) {
    return true;
  }

  const allowedRoutes = ["/Expedientes", "/Perfil"];

  if (canFreelanceViewArchivedFiles()) {
    allowedRoutes.push("/Archivados");
  }

  return allowedRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}
